export default "__VITE_ASSET__D74BO5m8__"